{
    "Accessibility Menu": "Мени За Приступачност",
    "Reset settings": "Ресетуј поставке",
    "Close": "Затвори",
    "Content Adjustments": "Подешавање Садржаја",
    "Adjust Font Size": "Подешавање Величине Фонта",
    "Highlight Title": "Означи Наслове",
    "Highlight Links": "Означи Везе",
    "Readable Font": "Читљивији Фонт",
    "Color Adjustments": "Подешавање Боја",
    "Dark Contrast": "Тамни Контраст",
    "Light Contrast": "Свијетли Контраст",
    "High Contrast": "Високи Контраст",
    "High Saturation": "Велика Засићеност",
    "Low Saturation": "Ниска Засићеност",
    "Monochrome": "Једнобојни",
    "Protanopia": "Протанопија",
    "Deuteranopia": "Деутеранопија",
    "Tritanopia": "Тританопија",
    "Visual & Navigation Aids": "Визуелни и навигацијски помагачи",
    "Additional Tools": "Додатни алати",
    "Reading Guide": "Водич За Читање",
    "Stop Animations": "Заустави Анимације",
    "Big Cursor": "Велики Курсор",
    "Screen Reader": "Читач екрана",
    "Hide Images": "Сакриј слике",
    "Image Tooltips": "Савети за слике",
    "Page Structure": "Структура странице",
    "Super Focus": "Супер Фокус",
    "Magnifier": "Увеличало",
    "Increase Font Size": "Повећај Величину Фонта",
    "Decrease Font Size": "Смањи Величину Фонта",
    "Letter Spacing": "Размак Слова",
    "Line Height": "Висина Линије",
    "Font Weight": "Дебљина Фонта",
    "Dyslexia Font": "Фонт За Дислексичаре",
    "Language": "Језик",
    "Open Accessibility Menu": "Отвори Мени За Приступачност",
    "Accessibility Profiles": "Профили приступачности",
    "Seizure Safe Profile": "Безбедан профил за епилептичаре",
    "Stops animations and reduces color saturation.": "Зауставља анимације и смањује засићеност боја.",
    "Blind Profile": "Профил за слепе",
    "Activates the screen reader for auditory navigation.": "Активира читача екрана за звучну навигацију.",
    "Visually Impaired Profile": "Профил за слабовидне",
    "Enhances contrast and readability for low vision.": "Побољшава контраст и читљивост за слабовидне.",
    "ADHD Friendly Profile": "Профил погодан за ADHD",
    "Reduces distractions for better focus.": "Смањује ометање за бољу концентрацију.",
    "Cognitive & Learning Profile": "Когнитивни и образовни профил",
    "Helpful tools for reading and comprehension.": "Корисни алати за читање и разумевање.",
    "Motor Impaired Profile": "Профил за моторичке потешкоће",
    "Optimizes the site for keyboard-only navigation.": "Оптимизује сајт за навигацију само тастатуром.",
    "Headings": "Наслови",
    "Landmarks": "Оријентири",
    "Links": "Везе",
    "Focus element": "Фокусирај елемент",
    "Visit link": "Посетити везу"
}
